import { render, staticRenderFns } from "./FooterAddBtn.vue?vue&type=template&id=13c30b7a&"
import script from "./FooterAddBtn.vue?vue&type=script&lang=js&"
export * from "./FooterAddBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports